<template>
  <div class="sm-org-reports" :class="{ 'sm-reports': !isGlobalReport }">
    <div class="sm-org-reports__main">
      <div class="sm-top admin">
        <div class="sm-wrap lg">
          <div class="sm-top__org-reports" :class="{ 'margin-top': !isGlobalReport }">
            <breadcrumbs-block v-if="!isMobile && breadcrumbs && !isGlobalReport" :crumbs="breadcrumbs" />
          </div>

          <div v-if="!isGlobalReport" class="sm-top__title-org-admin">
            <a class="icon-wrapper" href="#" @click.prevent="$router.push('org-reports')">
              <include-svg :name="'icon-org-admin-reports'" />
            </a>
            <h3>Organization Reports</h3>
          </div>

          <div class="sm-org-reports__form">
            <div class="sm-org-reports__form--group display-by">
              <div>Display by</div>

              <dropdown-block v-model="formData.display_by" class="sm-dropdown sm-txt-capitalize-first"
                :class="displayByOptions.length < 2 ? 'disabled' : ''" :options="displayByOptions" :searchable="false"
                :allow-empty="false" style="min-width:200px">
                <template slot="placeholder">
                  <span>Select Option</span>
                  <include-svg :name="'icon-arrow-b'" />
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span v-if="props.option">{{
                    formatDisplayByOption(props.option)
                  }}</span>
                  <include-svg :name="'icon-arrow-b'" />
                </template>
                <template slot="option" slot-scope="props" :value="props.option">
                  <span v-if="props.option">{{
                    formatDisplayByOption(props.option)
                  }}</span>
                </template>
              </dropdown-block>
            </div>

            <div class="sm-org-reports__form--group display-cols-by">
              <div>Display column by</div>
              <dropdown-block v-model="formData.display_columns_by" class="sm-dropdown sm-txt-capitalize"
                :class="displayColumnsByOptions.length < 2 ? 'disabled' : ''" :options="displayColumnsByOptions"
                :searchable="false" :allow-empty="false">
                <template slot="placeholder">
                  <span>Select Option</span>
                  <include-svg :name="'icon-arrow-b'" />
                </template>
                <template slot="singleLabel" slot-scope="props">
                  <span v-if="props.option">{{
                    props.option.replace(/_/g, "")
                  }}</span>
                  <include-svg :name="'icon-arrow-b'" />
                </template>
                <template slot="option" slot-scope="props" :value="props.option">
                  <span v-if="props.option">{{
                    props.option.replace(/_/g, "")
                  }}</span>
                </template>
              </dropdown-block>
            </div>

            <div v-if="userAccount.role == 'manager'" class="sm-org-reports__form--group organization">
              <div>Organization</div>
              <dropdown-wrap v-model="selectedOrganization" :val="selectedOrganization" :options="organizations" :capitalize="false"
                :label="''" @input="formData.organization_id = selectedOrganization.value" :params="{searchable:true , trackBy: 'name' , label: 'name'}" />
            </div>


            <div v-if="!isGlobalReport || (isGlobalReport && (userAccount.role == 'manager' || userAccount.is_organization_admin))" class="sm-org-reports__form--group location">
              <div>Location</div>
              <dropdown-wrap v-model="selectedLocation" :val="locations[0]" :options="locations" :capitalize="false"
                :label="''" @input="formData.location_id = selectedLocation.value" :params="{searchable:true , trackBy: 'name' , label: 'name'}"/>
            </div>

            <div class="sm-org-reports__form--group report-period">
              <div>
                <div>Report Period</div>
                <dropdown-block v-model="selectedPeriod" class="sm-dropdown sm-txt-capitalize"
                  :class="periods.length < 2 ? 'disabled' : ''" :options="periods" :searchable="false"
                  :allow-empty="false">
                  <template slot="placeholder">
                    <span>Select period</span>
                    <include-svg :name="'icon-arrow-b'" />
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <span v-if="props.option">{{
                      props.option.replace(/_/g, "")
                    }}</span>
                    <include-svg :name="'icon-arrow-b'" />
                  </template>

                  <template slot="option" slot-scope="props" :value="props.option">
                    <span v-if="props.option">{{
                      props.option.replace(/_/g, "")
                    }}</span>
                  </template>
                </dropdown-block>
              </div>
            </div>
            <div class="sm-org-reports__form--group from-to" v-if="formData.display_columns_by === 'months' &&
                formData.report_period === 'summary'
                ">
              <div class="row">
                <p>as of</p>
                <dropdown-wrap v-model="selectedYear" :val="selectedYear" :options="years" :clearable="false" />
              </div>
            </div>
            <div class="sm-org-reports__form--group from-to" v-if="selectedPeriod === 'Custom Period' || selectedPeriod === 'Today'
              ">
              <div class="row">
                <p v-if="selectedPeriod === 'Today'">as of</p>
                <datepicker-wrap :val="formData.from" :outerVal="formData.from"
                  :notAfter="formData.to ? formData.to : null" :placeholder="'From'" :type="'date'"
                  @input="(val) => selectDate(val, 'from')" />
                <datepicker-wrap v-if="selectedPeriod === 'Custom Period'" :val="formData.to" :outerVal="formData.to"
                  :notBefore="formData.from ? formData.from : null" :placeholder="'To'" :type="'date'"
                  @input="(val) => selectDate(val, 'to')" />
              </div>
            </div>

            <!-- <div class="sm-org-reports__form--group blank" v-if="formData.display_columns_by !== 'months' &&
              selectedPeriod !== 'Today' &&
              selectedPeriod !== 'Custom Period'
              "></div>
            <div class="sm-org-reports__form--group blank" v-if="selectedPeriod !== 'Custom Period'"></div> -->

            <div class="sm-org-reports__form--group sumbit">
              <btn-block :type="'submit'" :text="'Run Report'" :class="[
                'sm-btn--small',
                { 'disabled grey-if-disabled': btnDisabled },
              ]" @click="runReport(formData)" />
            </div>
          </div>
          <div class="sm-org-reports__download-btns">
            <div v-show="false">
              <a :href="`${pdfLink}`" :ref="'pdfLink'" target="_blank">
                Pdf Link
              </a>
              <a :href="`${xlsxLink}`" :ref="'xlsxLink'" target="_blank">
                xlsx Link
              </a>
            </div>
            <btn-block :type="'small'" :text="'Export as PDF'" :class="'sm-btn--grey-3'" :icon="'icon-pdf-export'"
              :classes="[{ disabled: (report && !report.length) || locations.length >= 20 }]" @click="downloadReport('pdf')" />
            <btn-block :type="'small'" :text="'Export as Excel'" :class="'sm-btn--grey-3'" :icon="'icon-xlsx-export'"
              :classes="[{ disabled: report && !report.length }]" @click="downloadReport('xlsx')" />
          </div>

          <org-admin-reports-table v-show="report.length" :report="report" :allowExpand="lastFormData.display_by !== 'product_used' &&
            lastFormData.display_columns_by !== 'locations'
            " :priceFormat="lastFormData.display_by !== 'product_used'" />

          <div class="sm-txt-center" v-show="!report.length">No data.</div>
        </div>
      </div>
    </div>
    <sm-spinner :show="showSpinner" :isGlobal="isGlobalReport ? false : true" />
  </div>
</template>

<script>
import PaginateBlock from "@/components/PaginateBlock";
import Spinner from "@/components/Spinner.vue";
import { mapActions, mapGetters } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import Multiselect from "vue-multiselect";
import Dates from "@/settings/dates";
import DatepickerWrap from "@/components/DatepickerWrap";
import Table from "@/views/admin/pages/reports/components/org-admin-reports/Table";
import DropdownWrap from "@/components/DropdownWrap";
import { Years } from "@/utils/time";

export default {
  name: "org-reports",
  components: {
    "sm-spinner": Spinner,
    "paginate-block": PaginateBlock,
    "breadcrumbs-block": Breadcrumbs,
    "dropdown-block": Multiselect,
    "datepicker-wrap": DatepickerWrap,
    "org-admin-reports-table": Table,
    "dropdown-wrap": DropdownWrap,
  },
  props: {
    isGlobalReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locations: [{ name: "All Locations", value: null }],
      selectedLocation: {},
      organizations: [],
      selectedOrganization: {name: "Select Organization", value: null },
      more: [],
      canShowMore: false,
      morePages: 0,
      pageLimit: 9,
      currentClientId: null,
      showSpinner: false,
      breadcrumbs: [
        {
          link: "locations",
          name: "org-admin-locations",
          text: "Locations",
        },
        {
          link: "org-reports",
          name: "org-reports",
          text: "Reports",
          current: true,
        },
      ],
      formData: {
        organization_id: null,
        location_id: null,
        display_by: "revenue_by_product",
        report_period: "summary",
        display_columns_by: "total",
      },
      lastFormData: {
        organization_id: null,
        location_id: null,
        display_by: "revenue_by_product",
        report_period: "summary",
        display_columns_by: "total",
      },
      btnDisabled: true,
      report: [],
      pdfLink: null,
      xlsxLink: null,
      selectedPeriod: "Summary",
      periods: [
        "Summary",
        "Custom Period",
        "Today",
        "This Month",
        "Last Month",
        "This Quarter",
        "Last Quarter",
        "This Year",
        "Last Year",
      ],
      displayByOptions: [
        "revenue_by_product",
        "revenue_by_customers",
        "product_used",
      ],
      displayColumnsByOptions: [
        "total",
        "months",
        "quarters",
        "years",
        "locations",
      ],
      // locations: [],
      years: Years,
      selectedYear: Years[0],
    };
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      userAccount: "account/userAccount",
      access: "auth/access",
      provider: "provider",
      list: 'operators/list',
    }),
  },
  created() {
    this.showSpinner = true;
    this.userData().then((res) => {
      if (!this.isGlobalReport && !res.account.is_organization_admin) {
        this.$router.push("/");
      }
      if (!this.isGlobalReport || (this.isGlobalReport && (res.account.role == 'manager' || res.account.is_organization_admin))){
        this.getLocations()
        if(res.account.role == 'manager' || res.account.is_organization_admin) {
          this.getAllOrganizations()
          this.getOperators()
        }
      
      };
    }).finally(() => {
      this.showSpinner = false;
    });
    this.runReport(this.formData);
  },
  methods: {
    ...mapActions({
      userData: "account/userData",
      getOrgAdminLocations: "auth/getLocationsOfOrgAdmin",
      getOrganizations: "auth/getOrganizations",
      getOrgReport: "reports/getOrgReport",
      fetchOperators: 'operators/fetchOperators',
    }),
    dates: Dates,
    formatDisplayByOption(str) {
      if (str === "revenue_by_product") return "Revenue by Product";
      else if (str === "revenue_by_customers") return "Revenue by Customer";
      else if (str === "product_used") return "Times a Product Is Used";
      else return str.charAt(0).toUpperCase() + str.replace(/_/g, " ").slice(1);
    },
    getLocations() {
      this.showSpinner = true;
      const params = {
        page: 1,
        limit: 10000000,
      };

      return this.getOrgAdminLocations(params).then((res) => {
        this.locations = [
          { name: "All Locations", value: null },
          ...res.clients.filter(client => client.client_level === 2).map((client) => ({
            name: client.name,
            value: client.id,
          })),
        ];
      });
    },
    getAllOrganizations() {
      this.showSpinner = true;

      return this.getOrganizations().then((res) => {
        this.organizations = [
          ...res.map((organization) => ({
            name: organization.name,
            value: organization.id,
          })),
        ];
      });
    },
    runReport(queryParams) {
      this.showSpinner = true;
      let params = { ...queryParams };

      if (this.isGlobalReport){
        let location_id;
        if(this.userAccount.role === "manager" || this.userAccount.is_organization_admin){
          location_id = this.selectedLocation.value
        } else {
          location_id = this.provider.id 
        }

        params = { ...queryParams, location_id};
      }

      this.lastFormData = { ...params };
      this.getOrgReport({ params }).then((res) => {
        this.report = res.items;
        this.pdfLink = res.pdf_url;
        this.xlsxLink = res.xlsx_url;
        setTimeout(() => {
          this.showSpinner = false;
        }, 300);
        this.btnDisabled = true;
      }).catch(e=> null);
    },
    handleSelectedPeriodChange(reportPeriod) {
      const { from, to, report_period, year, ...unrelatedData } = this.formData;

      const {
        today,
        currMonthStart,
        currMonthEnd,
        lastMonthStart,
        lastMonthEnd,
        currQuarterStart,
        currQuarterEnd,
        lastQuarterStart,
        lastQuarterEnd,
        currYearStart,
        currYearEnd,
        lastYearStart,
        lastYearEnd,
      } = this.dates(this.$moment);

      const periods = {
        Summary: { report_period: "summary" },
        "Custom Period": { from: "", to: "" },
        Today: { from: today, to: today },
        "This Month": { from: currMonthStart, to: currMonthEnd },
        "Last Month": { from: lastMonthStart, to: lastMonthEnd },
        "This Quarter": { from: currQuarterStart, to: currQuarterEnd },
        "Last Quarter": { from: lastQuarterStart, to: lastQuarterEnd },
        "This Year": { from: currYearStart, to: currYearEnd },
        "Last Year": { from: lastYearStart, to: lastYearEnd },
      };

      if (reportPeriod !== "Summary")
        periods[reportPeriod].report_period = "selected_period";

      this.formData = { ...unrelatedData, ...periods[reportPeriod] };
    },
    selectDate(val, param) {
      let date;
      if (param === "from") {
        date = val;
      } else if (param === "to") {
        date = val;
      }

      this.formData[param] = date;
    },
    sortObject(obj) {
      return Object.keys(obj)
        .sort()
        .reduce((result, key) => {
          result[key] = obj[key];
          return result;
        }, {});
    },
    downloadReport(type) {
      if (type === "pdf" && this.pdfLink) this.$refs.pdfLink.click();
      else if (type === "xlsx" && this.xlsxLink) this.$refs.xlsxLink.click();
    },
    async getOperators(org_id) {
            this.checkAll = false;
            //this.morePages++;
            let query = Object.assign({}, this.$route.query);
            // query.page = this.pager.page;
            query.limit = 1000000000;
            query.org_id= org_id

            if (query.order)
                query.order = JSON.parse(decodeURIComponent(query.order));
            this.fetchOperators(query);
        }
  },
  watch: {
    selectedPeriod(val) {
      this.handleSelectedPeriodChange(val);
    },
    selectedOrganization(organization) {
      if(this.userAccount.role == 'manager') {
        this.getOperators(organization.value)
      }
    },
    formData: {
      deep: true,
      handler(val) {
        if (
          JSON.stringify(this.sortObject(this.formData)) ===
          JSON.stringify(this.sortObject(this.lastFormData))
        ) {
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
        }

        if (val.display_columns_by === "months") {
          this.formData.year = this.selectedYear.value;
        } else {
          if (val.year) delete this.formData.year;
        }

        if (val.report_period === "selected_period" && (!val.from || !val.to)) {
          this.btnDisabled = true;
        }
      },
    },
    selectedLocation(location) {
      this.formData.location_id = location.value;
    },
    selectedYear(val) {
      this.formData.year = val.value;
      this.btnDisabled = false;
    },
    provider(val) {
      if (val && val.client_level && val.client_level !== 2) {
        this.$router.push("/");
      }
    },
    list(val){
      if(val){
        const locations = [{ name: "All Locations", value: null } , ...val.clients.map(({id , name}) => ({name, value: id}))]

        // const locations = val.clients.filter(client => client.client_level === 2).map(({id , name}) => ({name, value: id}))
        this.locations = locations
      }
    }
  },
};
</script>



<style lang="scss">
@use "@/assets/scss/general/mixins.scss" as *;
@use "@/assets/scss/framework/scss-variables.scss" as *;
@use "@/assets/scss/pages/common/mail/_top.scss";

.sm-org-reports {
  &__form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    border: 1px solid var(--grey-line);
    border-radius: 12px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.14);
    margin-bottom: 15px;
    padding: 0;

    @include media("<=tiny") {
      padding: 15px;
    }

    &--group {
      display: flex;
      flex-direction: column;
      min-width: calc(100% / 6 - 240px);
      height: 100%;
      flex-grow: 1;
      padding: 10px 20px;

      &.display-by,
      &.display-cols-by,
      &.organization,
      &.location {
        border-right: 1px solid var(--grey-line);

        @include media("<=tiny") {
          border-right: none;
        }
      }

      @include media("<=medium") {
        border-bottom: 1px solid var(--grey-line);
      }

      @include media("<=tiny") {
        border-bottom: none;
        padding: 7px 7px;
      }

      &.display-by {
        min-width: 260px;
        // max-width: 260px;
        // width: 260px;
      }

      &.display-by,
      &.submit {
        @include media("<=medium") {
          min-width: 15%;
        }

        @include media("<=tiny") {
          min-width: 100%;
        }
      }

      &.from-to {
        @include media("<=medium") {
          min-width: 50%;
        }

        @include media("<=tiny") {
          min-width: 100%;
        }
      }

      &.display-cols-by {
        min-width: 180px;
        max-width: 180px;
        width: 180px;
      }

      &.display-cols-by,
      &.report-period {
        flex: 0 !important;
        @include media("<=medium") {
          min-width: 25%;
        }

        @include media("<=tiny") {
          min-width: 50%;
        }
      }

      &.organization {
        min-width: 230px;
        max-width: 230px;
        width: 230px;
        flex: 0 !important;

      }

      &.location {
        min-width: 185px;
        max-width: 185px;
        width: 185px;
        flex: 0 !important;
      }

      &.report-period {
        // padding-right: 0;

        min-width: 200px;
        max-width: 200px;
        width: 200px;
        flex: 0 !important;

        @include media("<=medium") {
          padding-right: 10px;
        }
      }

      &.blank {
        @include media("<=medium") {
          min-width: 0;
          max-width: 0;
          padding: 0;
        }

        @include media("<=tiny") {
          min-width: 0;
          max-width: 0;
          padding: 0;
        }
      }

      & .row {
        display: flex;
        flex-direction: row;
        align-items: center;

        &>p {
          margin-right: 10px;
          white-space: nowrap;
        }

        & .sm-datepicker-wrap,
        & .sm-dropdown-wrap {
          width: 100%;

          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }

  &__download-btns {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;

    >.sm-btn {
      margin-left: 10px;
    }
  }

  &-controls {
    display: flex;
    align-items: center;
    position: relative;
    height: 40px;
    width: 100%;
    background-color: var(--grey-4);
    border-radius: 8px;

    &:before {
      content: "";
      position: absolute;
      top: 4px;
      right: 4px;
      width: calc(50% - 4px);
      height: 32px;
      background-color: var(--white);
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      transition: right 0.3s ease;
    }

    &.active-card {
      &:before {
        right: 50%;
      }
    }

    &>li {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 50%;
      height: 36px;
      cursor: pointer;

      &.active {
        &>span {
          color: var(--sys);
          font-weight: 600;

          &:hover {
            color: var(--sys-hover);
          }
        }
      }

      &>span {
        transition: color 0.3s ease;

        &:hover {
          color: var(--sys);
        }
      }
    }
  }

  & .controls {
    margin-bottom: 10px;
  }

  & .expand-all-btn {
    color: var(--sys);
    margin-left: 5px;
    margin-bottom: 10px;
  }
}
</style>
